<template>
  <div class="patentList fatherHeight contBox">
    <div class="bar-title">挂号信息</div>
    <div>
      <div class="search-top">
        <el-form
          :inline="true"
          :model="formData"
          ref="searchForm"
          :label-width="80"
          size="small"
          label-suffix=":"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="searchData.name"
              type="text"
              clearable
              placeholer="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="searchData.cert_no"
              type="text"
              clearable
              placeholer="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              v-model="searchData.time"
              type="daterange"
              range-separator="-"
              placeholder="请选择"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button @click="handleSearch" class="color-main" type="primary">
              <i class="fa fa-search"></i>查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="patientList" ref="tableBoxRef">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="透析治疗" name="1">
          <div class="table">
            <el-table
              v-loading="dataListLoading"
              v-if="istable"
              :data="tableData"
              class="table-ellipsis"
              size="small"
              border
              :max-height="tableHei"
            >
              <el-table-column
                type="index"
                label="序号"
                fixed
                min-width="60"
                align="center"
              >
                <template #default="scope">
                  {{
                    (pageData.currentPage - 1) * pageData.pageSize +
                    (scope.$index + 1)
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="schedule_date" fixed label="排班时间" show-overflow-tooltip width="120" />
              <el-table-column prop="nm_name" fixed align="center" label="班次" width="80" >
                <template #default="scope">
                  <el-tag v-if="scope.row.nm_name == '上午'" type="primary" size="small">{{ scope.row.nm_name }}</el-tag>
                  <el-tag v-if="scope.row.nm_name == '下午'" type="warning" size="small">{{ scope.row.nm_name }}</el-tag>
                  <el-tag v-if="scope.row.nm_name == '晚上'" type="info" size="small">{{ scope.row.nm_name }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                fixed
                label="姓名"
                show-overflow-tooltip
                width="100"
              />
              <el-table-column
                prop="dict_sex_name"
                label="性别"
                align="center"
                show-overflow-tooltip
                width="60"
              />
              <el-table-column
                prop="age"
                label="年龄"
                align="center"
                show-overflow-tooltip
                width="60"
              />
              <el-table-column label="结算类别" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="warning"
                    v-if="scope.row.dict_pay_cate == '1001'"
                    size="small"
                    >自费</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.dict_pay_cate == '4040'"
                    size="small"
                    >医保</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="bed_time"
                label="挂号时间"
                show-overflow-tooltip
                width="100"
              />
              <el-table-column
                prop="ipt_otp_no"
                label="门诊号"
                show-overflow-tooltip
                width="150"
              />
              <el-table-column
                prop="mdtrt_id"
                label="就诊id"
                show-overflow-tooltip
                width="150"
              />
              <el-table-column
                prop="setl_id"
                label="结算id"
                show-overflow-tooltip
                width="150"
              />
              
              <el-table-column label="医保挂号" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_reg == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_reg == '1'"
                    size="small"
                    closable
                    @close="closeReg(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_reg == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保诊断" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_diag == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_diag == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_diag == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="费用明细" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_fee == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_fee == '1'"
                    size="small"
                    closable
                    @close="closeFee(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_fee == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保预结算" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_presettle == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_presettle == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_presettle == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保结算" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_settle == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_settle == '1'"
                    size="small"
                    closable
                    @close="closeSettle(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_settle == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="结算清单" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_setl_list == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_setl_list == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="160"
                align="center"
              >
                <template #default="scope">
                  <el-link type="info"
                    @click="jsConfirms(scope.row)"
                    v-if="scope.row.upload_settle == '1'"
                  >
                    详
                  </el-link>
                  <el-link type="primary"
                    @click="addJieSuanDan(scope.row)"
                    v-if="
                      scope.row.upload_settle == '1' &&
                      scope.row.dict_pay_cate == '4040'
                    "
                  >
                    上传结算清单
                  </el-link>
                  <el-link type="primary"
                    @click="modParient(scope.row, scope.row.bed_reg_id)"
                    v-if="
                      scope.row.upload_settle == '0' ||
                      scope.row.upload_settle == '2' ||
                      scope.row.upload_settle == '' ||
                      scope.row.upload_settle == null
                    "
                  >
                    结算
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                :currentPage="pageData.currentPage"
                :page-size="pageData.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :background="true"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageData.totalSum"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="普通门诊" name="2">
          <div class="table">
            <el-table
              v-loading="dataListLoading"
              v-if="istable"
              :data="tableData2"
              class="table-ellipsis"
              size="small"
              border
              :max-height="tableHei"
            >
              <el-table-column
                type="index"
                label="序号"
                fixed
                min-width="80"
                align="center"
              >
                <template #default="scope">
                  {{
                    (pageData2.currentPage - 1) * pageData2.pageSize +
                    (scope.$index + 1)
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="patient_name"
                fixed
                label="姓名"
                show-overflow-tooltip
                width="100"
              />
              <el-table-column
                prop="dict_sex_name"
                label="性别"
                align="center"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column
                prop="age"
                label="年龄"
                align="center"
                show-overflow-tooltip
                width="80"
              />
              <el-table-column label="结算类别" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="warning"
                    v-if="scope.row.dict_pay_cate == '1001'"
                    size="small"
                    >自费</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.dict_pay_cate == '4040'"
                    size="small"
                    >医保</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="ipt_otp_no"
                label="门诊号"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column
                prop="mdtrt_id"
                label="就诊id"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column
                prop="setl_id"
                label="结算id"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column
                prop="bed_time"
                label="挂号时间"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column label="医保挂号" width="200" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_reg == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_reg == '1'"
                    size="small"
                    closable
                    @close="closeReg(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_reg == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保诊断" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_diag == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_diag == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_diag == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="费用明细" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_fee == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_fee == '1'"
                    size="small"
                    closable
                    @close="closeFee(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_fee == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保预结算" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_presettle == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_presettle == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_presettle == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="医保结算" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_settle == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_settle == '1'"
                    size="small"
                    closable
                    @close="closeSettle(scope.row)"
                    >已上传</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row.upload_settle == '2'"
                    size="small"
                    >已撤销</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="结算清单" width="100" align="center">
                <template #default="scope">
                  <el-tag
                    type="info"
                    v-if="scope.row.upload_setl_list == '0'"
                    size="small"
                    >未上传</el-tag
                  >
                  <el-tag
                    type="success"
                    v-if="scope.row.upload_setl_list == '1'"
                    size="small"
                    >已上传</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="160"
                align="center"
              >
                <template #default="scope">
                  <el-link type="info"
                    @click="jsConfirms(scope.row)"
                    v-if="scope.row.upload_settle == '1'"
                  >
                    详
                  </el-link>
                  <el-link type="primary"
                    @click="addJieSuanDan(scope.row)"
                    v-if="
                      scope.row.upload_settle == '1' &&
                      scope.row.dict_pay_cate == '4040'
                    "
                  >
                    上传结算清单
                  </el-link>
                  <el-link type="primary"
                    @click="modParient(scope.row, scope.row.bed_reg_id)"
                    v-if="
                      scope.row.upload_settle == '0' ||
                      scope.row.upload_settle == '2' ||
                      scope.row.upload_settle == '' ||
                      scope.row.upload_settle == null
                    "
                  >
                    结算
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                :currentPage="pageData2.currentPage"
                :page-size="pageData2.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :background="true"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageData2.totalSum"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <JieShuan
      v-if="isJieSuan"
      ref="jieShuanRef"
      @jsConfirm="jsConfirm"
    ></JieShuan>
    <JieShuanPT
      v-if="isJieShuanPT"
      ref="jieShuanPTRef"
      @jsConfirm="jsConfirm"
    ></JieShuanPT>
    <tuiFei
      v-if="istuiFei"
      ref="tuiFeiRef"
      @refreshDataList="handleSearch"
    ></tuiFei>
    <viewJieShuanFs
      v-if="isviewJieShuanFs"
      ref="viewJieShuanFsRef"
    ></viewJieShuanFs>
    <jieShuanFs
      v-if="isjieShuanFs"
      ref="jieShuanFsRef"
      @refreshDataList="handleSearch"
    ></jieShuanFs>
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import service from '@/utils/request'
import searchBox from '@/components/search/searchBox.vue'
import { gitDictList, gitDictVal, TimestampToTime } from '@/utils/tool'
import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
import JieShuan from '@/views/stack/outpatientPayment/components/jieShuan.vue'
import JieShuanPT from '@/views/stack/outpatientPayment/components/jieShuanPT.vue'
import tuiFei from '@/views/stack/outpatientPayment/components/tuiFei.vue'
import jieShuanFs from '@/views/stack/outpatientPayment/components/jieShuanFs.vue'
import { runInNewContext } from 'vm'
import viewJieShuanFs from '@/views/stack/outpatientPayment/components/viewJieShuanFs.vue'
export default {
  name: 'patentList',
  components: {
    tuiFei,
    JieShuan,
    jieShuanFs,
    searchBox,
    JieShuanPT,
    viewJieShuanFs,
  },
  setup() {
    let { proxy } = getCurrentInstance()
    const router = useRouter()
    const route = useRoute()
    const isJieSuan = ref(false)
    const isJieShuanPT = ref(false)
    const istuiFei = ref(false)
    const isviewJieShuanFs = ref(false)
    const isjieShuanFs = ref(false)
    const jieShuanRef = ref(null)
    const jieShuanPTRef = ref(null)
    const tuiFeiRef = ref(null)
    const viewJieShuanFs = ref(null)
    const state = reactive({
      isJieSuan: false,
      isJieShuanPT: false,
      isviewJieShuanFs: false,
      isjieShuanFs: false,
      jieShuanRef: null,
      searchData: {
        case_no: '', //病历号
        name: '', //姓名
        cert_no: '', //身份证号
        birth_date: '', //出生日期
        dict_medical_cate: '', //医疗证号
        doctor_id: '', //开单医生
        // dict_department: '',//开单科室
        upload_settle: '', //结算状态
        bed_start_time: '', //挂号开始
        bed_end_time: '', //挂号结束
        time: '',
        dict_pay_cate: '', //结算类别
        dict_sex: '', //性别
      },
      resultList: [
        {
          id: '1',
          name: '自费',
          code: '1001',
        },
        {
          id: '2',
          name: '医保',
          code: '4040',
        },
      ],
      upload_settleList: [
        {
          label: '未结算',
          value: '0',
        },
        {
          label: '已结算',
          value: '1',
        },
        {
          label: '已退费',
          value: '2',
        },
      ],
      formData: {},
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      pageData2: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      dataListLoading: false,
      tableData: [],
      tableData2: [],
      dictList: {},
      searchForm: null,
      statistic: '',
      istable: true,
      tableBoxRef: null,
      tableHei: 0,
      activeName: '1',
    })

    onMounted(() => {
      state.searchData.time = [TimestampToTime(), TimestampToTime()]
      state.istable = false
      state.tableHei = state.tableBoxRef.clientHeight - 130
      nextTick(() => {
        state.istable = true
      })
      initData()
      getDoctorList()
    })

    const handleSizeChange = (val) => {
      state.pageData.pageSize = val
      getDataList()
    }

    const handleCurrentChange = (val) => {
      state.pageData.currentPage = val
      getDataList()
    }
    const handleSizeChange2 = (val) => {
      state.pageData2.pageSize = val
      getDataList2()
    }
    const handleCurrentChange2 = (val) => {
      state.pageData2.currentPage = val
      getDataList2()
    }
    const getDoctorList = async () => {
      let res = await service.post('/api/user/list', {
        role_id: 1,
      })
      if (res.code === 0) {
        state.dictList.duty_doctor = res.data.records
      }
    }

    const initData = async () => {
      handleSearch()
      state.dictList = await gitDictList([
        '101000000',
        '210000000',
        '103000000',
        '323000000',
        '156000000',
      ])
      state.dictList[323000000].forEach((item) => {
        item.active = false
      })
    }

    const resetForm = () => {
      Object.keys(state.searchData).forEach(
        (key) => (state.searchData[key] = '')
      )
      state.searchData.time = [TimestampToTime(), TimestampToTime()]
      handleSearch()
    }

    const handleSearch = () => {
      if (state.activeName == '1') {
        state.pageData.currentPage = 1
        getDataList()
      } else {
        state.pageData2.currentPage = 1
        getDataList2()
      }
    }

    const getDataList = async () => {
      state.dataListLoading = true
      let data = {}
      if (state.searchData.time) {
        data = {
          bed_start_time: state.searchData.time[0],
          bed_end_time: state.searchData.time[1],
          current: state.pageData.currentPage,
          size: state.pageData.pageSize,
          // dict_department: state.searchData.dict_department,
          cert_no: state.searchData.cert_no,
          birth_date: state.searchData.birth_date,
          name: state.searchData.name,
          case_no: state.searchData.case_no,
          doctor_id: state.searchData.doctor_id,
          dict_status: '',
          dict_medical_cate: state.searchData.dict_medical_cate,
          dict_pay_cate: state.searchData.dict_pay_cate,
          upload_settle: state.searchData.upload_settle,
          dict_sex: state.searchData.dict_sex,
        }
      } else {
        data = {
          current: state.pageData.currentPage,
          size: state.pageData.pageSize,
          // dict_department: state.searchData.dict_department,
          cert_no: state.searchData.cert_no,
          birth_date: state.searchData.birth_date,
          name: state.searchData.name,
          doctor_id: state.searchData.doctor_id,
          dict_status: '',
          dict_medical_cate: state.searchData.dict_medical_cate,
          dict_pay_cate: state.searchData.dict_pay_cate,
          upload_settle: state.searchData.upload_settle,
          dict_sex: state.searchData.dict_sex,
        }
      }
      let res = await service.post('/api/bedReg/list', data)
      state.dataListLoading = false
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.tableData = res.data.records
          state.pageData.totalSum = res.data.total
          state.statistic = ''
        } else {
          state.tableData = []
          state.pageData.totalSum = 0
        }
      }
    }
    const getDataList2 = async () => {
      state.dataListLoading = true
      let data = {}
      if (state.searchData.time) {
        data = {
          bed_start_time: state.searchData.time[0],
          bed_end_time: state.searchData.time[1],
          current: state.pageData2.currentPage,
          size: state.pageData2.pageSize,
          cert_no: state.searchData.cert_no,
          name: state.searchData.name,
          birth_date: state.searchData.birth_date,
          doctor_id: state.searchData.doctor_id,
          treated: '1',
          dict_medical_cate: state.searchData.dict_medical_cate,
          dict_pay_cate: state.searchData.dict_pay_cate,
          upload_settle: state.searchData.upload_settle,
          dict_sex: state.searchData.dict_sex,
        }
      } else {
        data = {
          current: state.pageData2.currentPage,
          size: state.pageData2.pageSize,
          cert_no: state.searchData.cert_no,
          name: state.searchData.name,
          birth_date: state.searchData.birth_date,
          doctor_id: state.searchData.doctor_id,
          treated: '1',
          dict_medical_cate: state.searchData.dict_medical_cate,
          dict_pay_cate: state.searchData.dict_pay_cate,
          upload_settle: state.searchData.upload_settle,
          dict_sex: state.searchData.dict_sex,
        }
      }
      let res = await service.post('/api/bedReg/listNormal', data)
      state.dataListLoading = false
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.tableData2 = res.data.records
          state.pageData2.totalSum = res.data.total
        } else {
          state.tableData2 = []
          state.pageData2.totalSum = 0
        }
      }
    }
    const handleClick = (e) => {
      state.activeName = e.props.name
      console.log(state.activeName)
      if (state.activeName == '1') {
        getDataList()
      } else {
        getDataList2()
      }
    }
    // 撤销挂号
    const closeReg = (row) => {
      ElMessageBox.confirm('确认撤销挂号?', 'Warning', {
        confirmButtonText: '是',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        closeRegSubmit(row.bed_reg_id)
      })
    }

    // 费用明细撤销
    const closeFee = (row) => {
      ElMessageBox.confirm('确认撤销费用明细?', 'Warning', {
        confirmButtonText: '是',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        closeFeeSubmit(row.bed_reg_id)
      })
    }

    // 撤销结算
    const closeSettle = (row) => {
      ElMessageBox.confirm('确认撤销结算?', 'Warning', {
        confirmButtonText: '是',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        closeSettleSubmit(row.bed_reg_id)
      })
    }
    // 结算
    const modParient = async (item, id) => {
      if (id == '' || id == null) {
        ElMessage.error('请先挂号！')
        return
      }
      if (item.upload_settle == '0') {
        item.payName = '未结算'
      } else if (item.upload_settle == '1') {
        item.payName = '已结算'
      } else if (item.upload_settle == '2') {
        item.payName = '已退费'
      } else {
        item.payName = '-'
      }
      console.log(item.bed_reg_id)
      let type = ''
      let res = await service.post('/api/bedReg/detailNormal', {
        id: item.bed_reg_id,
      })
      if (res.code === 0) {
        type = res.data.data.upload_fee
        console.log(type)
        if (type == '1') {
          isjieShuanFs.value = true
          // item.typeDo = 'result'
          //已上传过药品明细
          proxy.$refs.jieShuanFsRef.visible = true
          //结算  1001自费    4040 api
          proxy.$refs.jieShuanFsRef.getDataList(item)
          proxy.$refs.jieShuanFsRef.saveType = 0
          proxy.$refs.jieShuanFsRef.info = item
        } else {
          if (state.activeName == '1') {
            isJieSuan.value = true
            nextTick(() => {
              proxy.$refs.jieShuanRef.visible = true
              proxy.$refs.jieShuanRef.info = item
              proxy.$refs.jieShuanRef.info.name = item.name
              proxy.$refs.jieShuanRef.getDataList(item.bed_reg_id)
              proxy.$refs.jieShuanRef.saveType = 0
            })
          } else {
            isJieShuanPT.value = true
            nextTick(() => {
              proxy.$refs.jieShuanPTRef.visible = true
              proxy.$refs.jieShuanPTRef.info = item
              proxy.$refs.jieShuanPTRef.info.name = item.patient_name
              // proxy.$refs.jieShuanPTRef.getDataList(item.id)
              proxy.$refs.jieShuanPTRef.saveType = 0
              proxy.$refs.jieShuanPTRef.getDataList(item.bed_reg_id)
            })
          }
        }
      }
    }

    const delParient = (item) => {
      console.log(proxy.$refs.tuifeiRef)
      proxy.$refs.tuiFeiRef.visible = true
      proxy.$refs.tuiFeiRef.info = item
    }

    const deatilsClick = async (item) => {
      // let res = await service.post('/api/patient/get_patient_detail', {
      //   patient_id: item.patient_id,
      // })
      // if (res.code === 0) {
      //   router.push({
      //     path: `/patients/patientDetails/${item.patient_id}`,
      //   })
      // }
    }

    // 撤销挂号
    const closeRegSubmit = async (bed_reg_id) => {
      let res = await service.post('/api/bedReg/cancel', {
        bed_reg_id: bed_reg_id,
      })
      if (res.code != 0) {
        ElMessage({
          type: 'error',
          message: '撤销失败',
        })
      } else {
        ElMessage({
          type: 'success',
          message: '撤销成功',
        })
      }
      if (state.activeName == '1') {
        getDataList()
      } else {
        getDataList2()
      }
    }

    // 明细撤销
    const closeFeeSubmit = async (bed_reg_id) => {
      let res = await service.post('/api/medical/cancel_fee_detail', {
        bed_reg_id: bed_reg_id,
      })
      if (res.code != 0) {
        ElMessage({
          type: 'error',
          message: '撤销失败',
        })
      } else {
        ElMessage({
          type: 'success',
          message: '撤销成功',
        })
      }
      if (state.activeName == '1') {
        getDataList()
      } else {
        getDataList2()
      }
    }
    // 结算撤销
    const closeSettleSubmit = async (bed_reg_id) => {
      let res = await service.post('/api/medical/cancel_sub_settle_accounts', {
        bed_reg_id: bed_reg_id,
      })
      if (res.code != 0) {
        ElMessage({
          type: 'error',
          message: '撤销失败',
        })
      } else {
        ElMessage({
          type: 'success',
          message: '撤销成功',
        })
      }
      if (state.activeName == '1') {
        getDataList()
      } else {
        getDataList2()
      }
    }
    function jsConfirms(row) {
      row.typeDo = 'view'
      jsConfirm(row)
    }
    // 结算方式
    function jsConfirm(e) {
      if (e.typeDo == 'view') {
        isviewJieShuanFs.value = true
        if (state.activeName == '1') {
          nextTick(() => {
            proxy.$refs.viewJieShuanFsRef.info = e
            proxy.$refs.viewJieShuanFsRef.visible = true
            //详情事件
            proxy.$refs.viewJieShuanFsRef.saveType = 0
            proxy.$refs.viewJieShuanFsRef.getDataListInfo(e)
            proxy.$refs.viewJieShuanFsRef.getData(e)
            proxy.$refs.viewJieShuanFsRef.getPayData(e)
          })
        } else {
          let obj = {
            name: e.patient_name,
            schedule_date: e.bed_time.substring(0, 11),
            case_no: e.case_no,
            cert_no: e.cert_no,
            dict_pay_cate: e.dict_pay_cate,
          }
          console.log(obj)
          nextTick(() => {
            proxy.$refs.viewJieShuanFsRef.info = obj
            proxy.$refs.viewJieShuanFsRef.visible = true
            //详情事件
            proxy.$refs.viewJieShuanFsRef.saveType = 0
            proxy.$refs.viewJieShuanFsRef.getDataListInfo(e)
            proxy.$refs.viewJieShuanFsRef.getData(e)
            proxy.$refs.viewJieShuanFsRef.getPayData(e)
          })
        }
      } else {
        isjieShuanFs.value = true
        nextTick(() => {
          proxy.$refs.jieShuanFsRef.saveType = 0
          proxy.$refs.jieShuanFsRef.info = e
          proxy.$refs.jieShuanFsRef.visible = true
          //结算  1001自费    4040 api
          proxy.$refs.jieShuanFsRef.getDataList(e)
        })
      }
    }
    //上传结算清单
    async function addJieSuanDan(row) {
      console.log(row)
      let data = {
        bed_reg_id: row.bed_reg_id,
      }
      const res = await service.post('/api/medical/fund_settlement', data)
      if (res.code == 0) {
        ElMessage.success('结算清单上传成功！')
        if (state.activeName == '1') {
          getDataList()
        } else {
          getDataList2()
        }
      } else {
        ElMessage.success('结算清单上传失败！')
      }
    }
    return {
      ...toRefs(state),
      closeReg,
      closeFee,
      closeSettle,
      closeRegSubmit,
      closeFeeSubmit,
      closeSettleSubmit,
      modParient,
      delParient,
      deatilsClick,
      handleSizeChange,
      handleCurrentChange,
      handleSizeChange2,
      handleCurrentChange2,
      handleSearch,
      getDataList,
      getDataList2,
      resetForm,
      jsConfirm,
      jsConfirms,
      getDoctorList,
      handleClick,
      addJieSuanDan,
      isJieShuanPT,
      isJieSuan,
      isjieShuanFs,
      isviewJieShuanFs,
    }
  },
}
</script>
<style lang="scss">
.el-notification__group {
  flex: 1;
}

.notice_but {
  text-align: right;
  color: #3167a8;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.demo-form-inline {
  margin-top: 0;
  //flex: 1;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  gap: 5px;
  align-items: center;

  .el-form-item {
    margin-bottom: 0;
  }
}

.search-top .w-208 {
  width: 208px;
}

.table-tag {
  margin-right: 8px;
}

.fa-stack {
  width: 24px;
  height: 24px;
  cursor: pointer;
  float: right;

  .fa-stack-2x {
    font-size: 24px;
    color: rgba(49, 102, 174, 0.1);
  }

  .fa-stack-1x {
    font-size: 12px;
    color: #3166ae;
    line-height: 24px;
  }
}

.tagBox {
  display: flex;
  justify-content: flex-start;

  // margin-bottom: 10px;
  .tit {
    width: 83px;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    font-weight: bold;
    color: #666666;
  }

  .cont {
    width: calc(100% - 83px);
  }
}

.patientList {
  margin-top: 4px;
  height: calc(100% - 155px);
}

.list-top {
  .name {
    font-size: 18px;
    font-family: ' Source Han Sans CN-Medium';
    font-weight: 500;
    color: #000000;
    line-height: 32px;
  }
}

.patient-alert {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 4px 4px 4px 4px;
  font-size: 18px;
  color: #3166ae;
  margin-top: 8px;
  padding: 4px 16px;

  .el-alert__icon {
    color: #3166ae;
  }

  &:deep(.el-alert__content) {
    position: relative;
    top: 3px;
  }
}

/* .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  } */

.searchBut {
  width: 100%;
  //margin-left: 20px;
  //margin-right: 29px;
  justify-self: right;
  display: flex;
  justify-content: end;
  margin-right: 28px;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.modify {
  background-color: #3166ae;
}

.bar-title {
  font-size: 18px;
  line-height: 18px;
  color: #000000;
  border-left: 6px solid #3166ae;
  padding: 0 18px;
  margin-bottom: 16px;
  font-weight: bold;
}
</style>
